module.exports = __webpack_public_path__ + "static/media/904ty@3x.3172ca9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/904ty@3x.png
// module id = 1698
// module chunks = 0 1